/** displayMetrics = metrics + exec metric overrides (CONF-212, CONF-258).
 *  Lives outside useConfigurationLogic on purpose: pricing and BOM must keep
 *  seeing the real metrics. CONF-258 retired the capacity-override branch —
 *  overrides now target each node's raw throughput rating
 *  (`metrics.throughputBasis`, attached by deriveOutputs/Task 1), never
 *  capacity, so there is no $/TB to re-derive here any more. */
import { useMemo } from 'react';
import {
  applyMetricOverrides, affectedMetricKeys, staleMetricKeys, hasMetricOverrides,
} from '../domain/MetricsOverrides';

const EMPTY = new Set();

export function useDisplayMetrics(metrics, overrides, { isPBUnit }) {
  return useMemo(() => {
    if (!metrics || !hasMetricOverrides(overrides)) {
      return { displayMetrics: metrics, affectedKeys: EMPTY, staleKeys: EMPTY };
    }
    const basis = metrics.throughputBasis;
    const ctx = { isPBUnit };
    return {
      displayMetrics: applyMetricOverrides(metrics, basis, overrides, ctx),
      affectedKeys: affectedMetricKeys(overrides),
      staleKeys: staleMetricKeys(basis, overrides),
    };
  }, [metrics, overrides, isPBUnit]);
}
